document.addEventListener('DOMContentLoaded', () => {
    // console.log('Megamenu script loaded')

    // Shared overlay utility for main content area
    function getMainOverlay() {
        // Get the hardcoded overlay from theme.liquid
        const overlay = document.querySelector('.main-overlay')
        // console.log('getMainOverlay() called, found overlay:', !!overlay)
        return overlay
    }

    function showMainOverlay() {
        // console.log('showMainOverlay() called')
        const overlay = getMainOverlay()
        if (overlay) {
            // console.log('Overlay found, removing opacity-0 class')
            // Remove the opacity-0 class and enable pointer events
            overlay.classList.remove('opacity-0')
            overlay.style.pointerEvents = 'auto'
            // console.log(
            //     'Opacity-0 class removed, classes now:',
            //     overlay.className
            // )
        } else {
            // console.error('Main overlay not found')
        }
    }

    function hideMainOverlay() {
        const overlay = getMainOverlay()
        if (overlay) {
            // Don't hide overlay if cart is open
            if (document.body.classList.contains('cart-open')) {
                return
            }

            // Add the opacity-0 class back and disable pointer events
            overlay.classList.add('opacity-0')
            overlay.style.pointerEvents = 'none'
        }
    }

    // Add click handler to the hardcoded overlay
    const overlay = getMainOverlay()
    if (overlay) {
        overlay.addEventListener('click', function () {
            // Close cart if it's open
            if (document.body.classList.contains('cart-open')) {
                document.body.classList.remove('cart-open')
                hideMainOverlay()
                return
            }

            // Close search modal if it's open
            if (document.body.classList.contains('search-focus')) {
                const searchElement = document.querySelector('main-search')
                if (searchElement && searchElement.closeSearch) {
                    searchElement.closeSearch()
                }
                return
            }

            // Close any MicroModal if it's open
            if (document.body.classList.contains('modal-open')) {
                const openModal = document.querySelector('.modal.is-open')
                if (openModal && window.MicroModal) {
                    window.MicroModal.close()
                }
                return
            }

            // Close quickview modal if it's open
            const quickviewModal = document.querySelector(
                '#quickViewModal.is-open'
            )
            if (quickviewModal && window._closeModal) {
                window._closeModal(quickviewModal)
                return
            }
        })
    }

    // Make overlay utilities available globally for other components
    window.MainOverlay = {
        show: showMainOverlay,
        hide: hideMainOverlay,
        get: getMainOverlay,
    }

    // Mega menu functionality - ONLY for desktop (LG+ breakpoint)
    const megamenuLinks = document.querySelectorAll('.megamenu__links li a')

    // console.log('Found megamenu links:', megamenuLinks.length)

    megamenuLinks.forEach((item) => {
        item.addEventListener('mouseover', function () {
            // Only handle mouseover on desktop (LG+ breakpoint)
            if (window.innerWidth >= 1024) {
                // console.log('Mouseover on megamenu link')
                const index = item.getAttribute('data-index')
                const megaMenu = item.closest('.megamenu')

                if (!megaMenu) return

                // Hide all sub-menu links
                megaMenu
                    .querySelectorAll('.megamenu__child_links li')
                    .forEach((link) => link.classList.add('hidden'))

                // Show the matching sub-menu links
                megaMenu
                    .querySelectorAll(
                        `.megamenu__child_links li[data-index="${index}"]`
                    )
                    .forEach((link) => link.classList.remove('hidden'))

                // Hide all images
                megaMenu
                    .querySelectorAll('.megamenu__images li')
                    .forEach((img) => img.classList.add('hidden'))

                // Show the matching images
                megaMenu
                    .querySelectorAll(
                        `.megamenu__images li[data-index="${index}"]`
                    )
                    .forEach((img) => img.classList.remove('hidden'))
            }
        })
    })

    // Mega menu trigger functionality
    let activeMenuTrigger = null
    let megaMenuTimeout = null

    const menuTriggers = document.querySelectorAll('[data-mega-menu]')
    // console.log('Found menu triggers:', menuTriggers.length)

    menuTriggers.forEach((trigger) => {
        const menuTarget = trigger.getAttribute('data-mega-menu')
        const megaMenuElement = document.querySelector(
            `[data-id="${menuTarget}"]`
        )

        // console.log('Menu target:', menuTarget)
        // console.log('Found megamenu element:', !!megaMenuElement)

        if (!megaMenuElement) {
            console.warn('No megamenu found for', menuTarget)
            return
        }

        // Handle hover/click to show megamenu (desktop only)
        function showMegaMenu() {
            // Only show megamenu on desktop (LG+ breakpoint)
            if (window.innerWidth < 1024) {
                return
            }

            // console.log('Showing megamenu')
            // Clear any existing timeout
            if (megaMenuTimeout) {
                clearTimeout(megaMenuTimeout)
                megaMenuTimeout = null
            }

            // Close any currently active megamenu
            if (activeMenuTrigger && activeMenuTrigger !== trigger) {
                activeMenuTrigger.removeAttribute('open')
                const prevMenuTarget =
                    activeMenuTrigger.getAttribute('data-mega-menu')
                const prevMegaMenuElement = document.querySelector(
                    `[data-id="${prevMenuTarget}"]`
                )
                if (prevMegaMenuElement) {
                    prevMegaMenuElement.classList.remove('megamenu-open')
                }
            }

            // Set the trigger as open and track it
            trigger.setAttribute('open', 'true')
            megaMenuElement.classList.add('megamenu-open')
            activeMenuTrigger = trigger

            // Show overlay using shared utility
            showMainOverlay()

            // console.log('Megamenu should be visible now')
        }

        // Handle mouse leave to hide megamenu (desktop only)
        function hideMegaMenu() {
            // Only hide megamenu on desktop (LG+ breakpoint)
            if (window.innerWidth < 1024) {
                return
            }

            // console.log('Hiding megamenu')
            megaMenuTimeout = setTimeout(() => {
                trigger.removeAttribute('open')
                megaMenuElement.classList.remove('megamenu-open')
                if (activeMenuTrigger === trigger) {
                    activeMenuTrigger = null
                }

                // Hide overlay using shared utility
                hideMainOverlay()
            }, 150) // Small delay to allow moving to megamenu
        }

        // Mouse events for desktop only (LG+ breakpoint)
        trigger.addEventListener('mouseenter', function () {
            if (window.innerWidth >= 1024) {
                showMegaMenu()
            }
        })
        trigger.addEventListener('mouseleave', function () {
            if (window.innerWidth >= 1024) {
                hideMegaMenu()
            }
        })

        // Click events for mobile/tablet accordion behavior
        trigger.addEventListener('click', function (e) {
            // console.log('Click on trigger', e.target.tagName, e.target.href)
            if (window.innerWidth < 1024) {
                // Mobile/tablet accordion behavior

                // Check if the click is on or inside a navigable link
                const clickedLink = e.target.closest('a')
                if (
                    clickedLink &&
                    clickedLink.href &&
                    clickedLink.href !== '#' &&
                    !clickedLink.href.endsWith('#')
                ) {
                    // console.log('Allowing navigation to:', clickedLink.href)
                    // Don't prevent default - let the link navigate
                    return
                }

                // Handle accordion-style toggle for mobile
                e.preventDefault()

                // Close any other open megamenus first (accordion behavior)
                const allTriggers =
                    document.querySelectorAll('[data-mega-menu]')
                allTriggers.forEach((otherTrigger) => {
                    if (
                        otherTrigger !== trigger &&
                        otherTrigger.hasAttribute('open')
                    ) {
                        const otherMenuTarget =
                            otherTrigger.getAttribute('data-mega-menu')
                        const otherMegaMenuElement = document.querySelector(
                            `[data-id="${otherMenuTarget}"]`
                        )
                        if (otherMegaMenuElement) {
                            otherMegaMenuElement.classList.remove(
                                'megamenu-open'
                            )
                        }
                        otherTrigger.removeAttribute('open')
                    }
                })

                // Toggle current megamenu
                if (trigger.hasAttribute('open')) {
                    trigger.removeAttribute('open')
                    megaMenuElement.classList.remove('megamenu-open')
                    activeMenuTrigger = null
                } else {
                    trigger.setAttribute('open', 'true')
                    megaMenuElement.classList.add('megamenu-open')
                    activeMenuTrigger = trigger
                }
            }
        })

        // Keep megamenu open when hovering over it (desktop only)
        megaMenuElement.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 1024 && megaMenuTimeout) {
                clearTimeout(megaMenuTimeout)
                megaMenuTimeout = null
            }
        })

        megaMenuElement.addEventListener('mouseleave', function () {
            if (window.innerWidth >= 1024) {
                hideMegaMenu()
            }
        })
    })

    // Close megamenu when clicking outside
    document.addEventListener('click', function (e) {
        if (activeMenuTrigger) {
            const menuTarget = activeMenuTrigger.getAttribute('data-mega-menu')
            const megaMenuElement = document.querySelector(
                `[data-id="${menuTarget}"]`
            )
            const isClickInsideTrigger = activeMenuTrigger.contains(e.target)
            const isClickInsideMegamenu =
                megaMenuElement && megaMenuElement.contains(e.target)

            if (!isClickInsideTrigger && !isClickInsideMegamenu) {
                activeMenuTrigger.removeAttribute('open')
                if (megaMenuElement) {
                    megaMenuElement.classList.remove('megamenu-open')
                }
                activeMenuTrigger = null

                // Hide overlay using shared utility (only on desktop)
                if (window.innerWidth >= 1024) {
                    hideMainOverlay()
                }
            }
        }
    })

    // Close megamenu when mouse moves outside both trigger and megamenu (desktop only)
    document.addEventListener('mousemove', function (e) {
        if (activeMenuTrigger && window.innerWidth >= 1024) {
            // Only on desktop (LG+ breakpoint)
            const menuTarget = activeMenuTrigger.getAttribute('data-mega-menu')
            const megaMenuElement = document.querySelector(
                `[data-id="${menuTarget}"]`
            )

            // Check if mouse is over trigger or megamenu
            const triggerRect = activeMenuTrigger.getBoundingClientRect()
            const megamenuRect = megaMenuElement
                ? megaMenuElement.getBoundingClientRect()
                : null

            const isOverTrigger =
                e.clientX >= triggerRect.left &&
                e.clientX <= triggerRect.right &&
                e.clientY >= triggerRect.top &&
                e.clientY <= triggerRect.bottom

            const isOverMegamenu =
                megamenuRect &&
                e.clientX >= megamenuRect.left &&
                e.clientX <= megamenuRect.right &&
                e.clientY >= megamenuRect.top &&
                e.clientY <= megamenuRect.bottom

            // If mouse is not over either element, start close timer
            if (!isOverTrigger && !isOverMegamenu) {
                if (!megaMenuTimeout) {
                    megaMenuTimeout = setTimeout(() => {
                        if (activeMenuTrigger) {
                            activeMenuTrigger.removeAttribute('open')
                            if (megaMenuElement) {
                                megaMenuElement.classList.remove(
                                    'megamenu-open'
                                )
                            }
                            activeMenuTrigger = null

                            // Hide overlay using shared utility
                            hideMainOverlay()
                        }
                        megaMenuTimeout = null
                    }, 150)
                }
            } else {
                // If mouse is back over trigger or megamenu, cancel close timer
                if (megaMenuTimeout) {
                    clearTimeout(megaMenuTimeout)
                    megaMenuTimeout = null
                }
            }
        }
    })

    // Close megamenu when pressing Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && activeMenuTrigger) {
            const menuTarget = activeMenuTrigger.getAttribute('data-mega-menu')
            const megaMenuElement = document.querySelector(
                `[data-id="${menuTarget}"]`
            )

            activeMenuTrigger.removeAttribute('open')
            if (megaMenuElement) {
                megaMenuElement.classList.remove('megamenu-open')
            }
            activeMenuTrigger = null

            // Hide overlay using shared utility (only on desktop)
            if (window.innerWidth >= 1024) {
                hideMainOverlay()
            }
        }
    })
})
